<template>
    <div>
        <div class="container-fluid">
            <div class="row">

                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item" v-if="type=='admin'">
                                <router-link :to="{path:'/admin/jugadores'}">Jugadores</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">{{ player.nombre | capitalizeText }}
                                {{ player.apellidos | capitalizeText }}
                            </li>
                        </ol>
                    </nav>
                </div>

                <div class="col-md-12">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="imgPlayer" @click="$refs.file.click()">
                                    <template v-if="player.img != ''">
                                        <img :src="player.img" id="img-player"
                                             class="img-fluid img-center rounded-circle align-middle">
                                    </template>
                                    <template v-else>
                                        <img src="img/player-img.png"
                                             class="img-fluid img-center rounded-circle align-middle">
                                    </template>
                                </div>

                                <input type="file" @change="uploadImage" accept="image/*" style="display: none;"
                                       ref="file" id="file" v-if="type=='admin'">

                            </div>
                            <div class="col-md-10" style="margin-top: 10px">

                                <div class="row">
                                    <div class="col-md-12">
                                        <h1 id="nombre-player">
                                            {{ player.nombre | capitalizeText }} {{ player.apellidos | capitalizeText }}
                                            <template v-if="type=='admin'">
                                                <button class="btn btn-success btn-sm" v-if="player.reserva === 1"
                                                        @click="openModalReservaPlayer(player.id)">
                                                    <i class="fas fa-clock"></i> Sacar de reserva
                                                </button>
                                                <button class="btn btn-warning btn-sm" v-if="player.baja == 0"
                                                        @click="openModalBajaPlayer(player.id)">
                                                    <i class="fas fa-clock"></i> Dar de baja
                                                </button>
                                                <button class="btn btn-success btn-sm" v-else
                                                        @click="openModalAltaPlayer(player.id)">
                                                    <i class="fas fa-clock"></i> Dar de alta
                                                </button>
                                                <button class="btn btn-danger btn-sm"
                                                        @click="openModalDeletePlayer(player.id)">
                                                    <i class="fas fa-times"></i> Eliminar
                                                </button>
                                            </template>

                                        </h1>

                                        <tabs>
                                            <tab-pane title="Información general">
                                                <div class="row" style="margin-top: 20px">
                                                    <div class="col-md-6">
                                                        <div>
                                                            Posición:
                                                            <strong>{{ player.posicion }}</strong>
                                                        </div>
                                                        <div>
                                                            Año de nacimiento:
                                                            <strong>{{ player.year }}</strong>
                                                        </div>
                                                        <div>
                                                            Equipo actual:
                                                            <strong>{{ player.club | capitalizeText }}</strong>
                                                        </div>
                                                        <div>
                                                            Talla: <strong>{{ player.talla }}</strong>
                                                        </div>
                                                        <div>
                                                            <strong>Notas / Observaciones</strong>:
                                                            {{ player.observaciones }}
                                                        </div>

                                                        <hr>
                                                        <template>
                                                            <h2>Inscripción
                                                                <button class="btn btn-sm btn-primary"
                                                                        @click="modalChangeInscripcion = true"
                                                                        v-if="player.inscripcion">
                                                                    Cambiar
                                                                    inscripción
                                                                </button>
                                                            </h2>


                                                            <p>
                                                                <strong>Modalidad: </strong>{{
                                                                    player.inscripcion.modalidad | parseModalidad
                                                                }}
                                                            </p>
                                                            <p>
                                                                <strong>Sede: </strong>{{
                                                                    player.inscripcion.hora1.sede
                                                                }}
                                                            </p>
                                                            <p>
                                                                <strong>Dia -
                                                                    Hora: </strong>{{ player.inscripcion.hora1.dia }}
                                                                {{ player.inscripcion.hora1.hora }}
                                                            </p>
                                                            <p v-if="player.inscripcion.modalidad.days === 2">
                                                                <strong>2º Dia -
                                                                    Hora: </strong>{{ player.inscripcion.hora2.dia }}
                                                                {{ player.inscripcion.hora2.hora }}
                                                            </p>
                                                        </template>


                                                    </div>
                                                    <div class="col-md-4">

                                                    </div>
                                                </div>
                                            </tab-pane>
                                            <tab-pane title="Tutores">
                                                <div class="row" style="margin-top: 20px">
                                                    <div class="col-md-4"
                                                         style="margin-bottom: 20px">
                                                        <div>
                                                            <i class="fa fa-id-card"></i>
                                                            <strong> {{ player.nombreTutor }}
                                                                {{ player.apellidosTutor }}</strong>
                                                        </div>
                                                        <div>
                                                            <a :href="'tel:'+player.telefono">
                                                                <i class="fa fa-phone"></i> {{ player.telefono }}
                                                            </a>
                                                        </div>
                                                        <div>
                                                            <a :href="'mailto:'+player.email">
                                                                <i class="fa fa-envelope"></i> {{ player.email }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </tab-pane>
                                            <tab-pane title="Pagos" v-if="type=='admin'">
                                                <div class="row" style="margin-top: 20px">
                                                    <div class="col-md-12">
                                                        <div class="table-responsive">
                                                            <table class="table table-striped" id="table-pays">
                                                                <thead>
                                                                <tr>
                                                                    <th>Mes</th>
                                                                    <th>Estado</th>
                                                                    <th v-if="type=='admin'">Acciones</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr>
                                                                    <td>Matrícula</td>
                                                                    <td>
                                                                         <span class="text-success"
                                                                               v-if="player.matricula != 0">
                                                                    <i class="fa fa-check"></i> Pagado
                                                                </span>
                                                                        <span class="text-danger" v-else>
                                                                    <i class="fa fa-times"></i> No pagado
                                                                </span>
                                                                    </td>
                                                                    <td class="text-center">
                                                                        <select class="form-control"
                                                                                v-model="cuotaMatricula"
                                                                                v-if="player.matricula == 0">
                                                                            <option value="20">Nuevos - 20 €</option>
                                                                            <option value="10">Antiguos - 10 €</option>
                                                                            <option value="0">0 €</option>
                                                                        </select>
                                                                        <button class="btn btn-success btn-sm"
                                                                                v-if="player.matricula == 0"
                                                                                @click="openModalMatricula(player)">
                                                                            <i class="fas fa-check"></i> Marcar como
                                                                            pagado
                                                                        </button>
                                                                        <button class="btn btn-danger btn-sm"
                                                                                @click="changeMatricula(player, 0)"
                                                                                v-else>
                                                                            <i class="fas fa-times"></i> Marcar como no
                                                                            pagado
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr v-for="(pay, index) in player.payments">
                                                                    <td>{{ index | parseMesPago }}</td>
                                                                    <td>
                                                                <span class="text-success" v-if="pay != 0">
                                                                    <i class="fa fa-check"></i> Pagado
                                                                </span>
                                                                        <span class="text-danger" v-else>
                                                                    <i class="fa fa-times"></i> No pagado
                                                                </span>
                                                                    </td>
                                                                    <td class="text-center" v-if="type=='admin'">
                                                                        <button class="btn btn-success btn-sm"
                                                                                v-if="pay == 0"
                                                                                @click="openModalPagarMes(1, index, pay, 'full')">
                                                                            <i class="fas fa-check"></i> Marcar como
                                                                            pagado
                                                                        </button>
                                                                        <button class="btn btn-primary btn-sm"
                                                                                v-if="pay == 0"
                                                                                @click="openModalPagarMes(1, index, pay, 'half')">
                                                                            <i class="fas fa-check"></i> Marcar como
                                                                            pagado MITAD MES
                                                                        </button>
                                                                        <button class="btn btn-dark btn-sm"
                                                                                v-if="pay == 0"
                                                                                @click="openModalPagarMes(1, index, pay, 'zero')">
                                                                            <i class="fas fa-check"></i> Marcar como
                                                                            nulo
                                                                        </button>
                                                                        <button class="btn btn-danger btn-sm"
                                                                                @click="pagarMes(0, index, pay, '')"
                                                                                v-else>
                                                                            <i class="fas fa-times"></i> Marcar como no
                                                                            pagado
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-12" style="margin-top: 20px">
                                                        <h3 class="text-right">
                                                            Total pagado: {{ getTotalPagado | currency }} /
                                                            {{ getTotalPayments | currency }}
                                                        </h3>
                                                    </div>
                                                </div>
                                            </tab-pane>
                                            <tab-pane title="Entrenamientos">
                                                <div class="col-md-12">
                                                    <div class="table-responsive">
                                                        <table class="table table-striped" id="table-trainings">
                                                            <thead>
                                                            <th>Fecha</th>
                                                            <th>Asistencia</th>
                                                            </thead>
                                                            <tbody>
                                                            <tr v-for="training in player.trainings">
                                                                <td>{{ training.fechaTraining | parseDate }}</td>
                                                                <td>
                                                                <span class="text-success"
                                                                      v-if="training.asistencia != 0">
                                                                    <i class="fa fa-check"></i> Entrenamiento realizado
                                                                </span>
                                                                    <span class="text-danger" v-else>
                                                                    <i class="fa fa-times"></i> No asistido
                                                                </span>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </tab-pane>
                                            <tab-pane title="Entrenadores" v-if="type=='admin'">
                                                <button class="btn btn-success" @click="modalAddCoach = true">Añadir
                                                    entrenador
                                                </button>
                                                <br><br>
                                                <table class="table table-striped table-borderless list-services">
                                                    <tbody>
                                                    <tr v-for="coach in player.coaches">
                                                        <td style="vertical-align: middle">{{ coach.name }}</td>
                                                        <td>
                                                            <button class="btn btn-danger btn-sm"
                                                                    @click="modalDeleteCoach(coach.coach_id)"><i
                                                                class="fa fa-times"></i></button>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </tab-pane>
                                        </tabs>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

        <modal :show.sync="modalEditPlayer">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Editar jugador</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-4" style="margin-bottom: 20px">
                        <label><strong>Nombre</strong></label>
                        <input type="text" class="form-control" v-model="playerEdit.nombre">
                    </div>
                    <div class="col-md-4" style="margin-bottom: 20px">
                        <label><strong>Apellidos</strong></label>
                        <input type="text" class="form-control" v-model="playerEdit.apellidos">
                    </div>
                    <div class="col-md-4" style="margin-bottom: 20px">
                        <label><strong>Club de origen</strong></label>
                        <input type="text" class="form-control" v-model="playerEdit.clubOfOrigin">
                    </div>
                    <div class="col-md-4" style="margin-bottom: 20px">
                        <label><strong>Centro de estudios</strong></label>
                        <input type="text" class="form-control" v-model="playerEdit.studyCentre">
                    </div>
                    <div class="col-md-4" style="margin-bottom: 20px">
                        <label><strong>Fecha de nacimiento</strong></label>
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                            <flat-picker slot-scope="{focus, blur}"
                                         @on-open="focus"
                                         @on-close="blur"
                                         :config="configDate"
                                         class="form-control datepicker"
                                         v-model="playerEdit.dateOfBirthday">
                            </flat-picker>
                        </base-input>
                    </div>
                    <div class="col-md-4" style="margin-bottom: 20px">
                        <label><strong>Notas / Observaciones</strong></label>
                        <input type="text" class="form-control" v-model="playerEdit.note">
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalEditPlayer = false">Cerrar</base-button>
                <base-button type="primary" @click="editPlayer">Guardar</base-button>
            </template>
        </modal>

        <modal :show.sync="modalAddCoach">
            <template slot="header">
                <h4 class="modal-title">Añadir entrenador</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-4" style="margin-bottom: 20px">
                        <label><strong>Entrenador</strong></label>
                        <select name="" id="" v-model="coachId" class="form-control">
                            <option v-for="coach in coaches" :value="coach.id">{{ coach.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalAddCoach = false">Cerrar</base-button>
                <base-button type="primary" @click="addCoach">Guardar</base-button>
            </template>
        </modal>

        <modal :show.sync="modalChangeInscripcion"
               v-if="player.inscripcion">
            <template slot="header">
                <h4 class="modal-title">Cambiar inscripcion</h4>
            </template>
            <div>
                <div class="form-group">
                    <label for="sede"><strong>Seleccione sede de
                        entrenamiento</strong></label>
                    <select name="sede" id="sede" class="form-control"
                            v-model="nuevaInscripcion.sede"
                            @change="loadModalidades(); changeDia()">
                        <option value="Sevilla Este">Sevilla Este</option>
                        <option value="Sevilla Este">Santiponce</option>
<!--                        <option value="Torreblanca">Torreblanca</option>-->
<!--                        <option value="Castilleja Cuesta">Castilleja de la Cuesta-->
<!--                        </option>-->
                    </select>
                </div>

                <div class="form-group">
                    <label for="modalidad"><strong>Seleccione modalidad</strong></label>
                    <select name="modalidad" id="modalidad" class="form-control"
                            v-model="nuevaInscripcion.modalidad"
                            @change="loadHoras()">
                        <option v-for="modalidad in modalidades" :value="modalidad">
                            {{ modalidad | parseModalidad }}
                        </option>
                    </select>
                </div>

                <template v-if="nuevaInscripcion.modalidad.days === 1">
                    <div class="form-group">
                        <label for="dia"><strong>Seleccione día de
                            entrenamiento</strong></label>
                        <select name="dia" id="dia" class="form-control"
                                v-model="nuevaInscripcion.dia"
                                @change="loadHoras()">
                            <option value="0">Domingo</option>
                            <option value="1">Lunes</option>
                            <option value="2">Martes</option>
                            <option value="3">Miércoles</option>
                            <option value="4">Jueves</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="hora"><strong>Seleccione hora de
                            entrenamiento</strong></label>
                        <select name="hora" id="hora" class="form-control"
                                v-model="nuevaInscripcion.horaId">
                            <option v-for="hora in horas"
                                    :value="hora.id">
                                <template v-if="nuevaInscripcion.modalidad.gym">
                                    {{ hora.hora + ' / ' + hora.year }}
                                </template>
                                <template v-else>
                                    {{ hora.hora }}
                                </template>
                            </option>
                        </select>
                    </div>
                </template>
                <template v-else>
                    <div class="form-group">
                        <label for="dia"><strong>Seleccione 1º día de
                            entrenamiento</strong></label>
                        <select name="dia" id="dia" class="form-control"
                                v-model="nuevaInscripcion.dia"
                                @change="loadHoras(1)">
                            <option value="0">Domingo</option>
                            <option value="1">Lunes</option>
                            <option value="2">Martes</option>
                            <option value="3">Miércoles</option>
                            <option value="4">Jueves</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="hora"><strong>Seleccione 1ª hora de
                            entrenamiento</strong></label>
                        <select name="hora" id="hora" class="form-control"
                                v-model="nuevaInscripcion.horaId">
                            <option v-for="hora in horas"
                                    :value="hora.id">
                                <template v-if="nuevaInscripcion.modalidad.gym">
                                    {{ hora.hora + ' / ' + hora.year }}
                                </template>
                                <template v-else>
                                    {{ hora.hora }}
                                </template>
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="dia"><strong>Seleccione 2º día de
                            entrenamiento</strong></label>
                        <select name="dia" id="dia" class="form-control"
                                v-model="nuevaInscripcion.dia2"
                                @change="loadHoras(2)">
                            <option value="0">Domingo</option>
                            <option value="1">Lunes</option>
                            <option value="2">Martes</option>
                            <option value="3">Miércoles</option>
                            <option value="4">Jueves</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="hora"><strong>Seleccione 2ª hora de
                            entrenamiento</strong></label>
                        <select name="hora" id="hora" class="form-control"
                                v-model="nuevaInscripcion.hora2Id">
                            <option v-for="hora in horas2"
                                    :value="hora.id">
                                <template v-if="nuevaInscripcion.modalidad.gym">
                                    {{ hora.hora + ' / ' + hora.year }}
                                </template>
                                <template v-else>
                                    {{ hora.hora }}
                                </template>
                            </option>
                        </select>
                    </div>
                </template>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalChangeInscripcion = false">Cerrar</base-button>
                <base-button type="primary" @click="changeInscripcion">Cambiar inscripcion</base-button>
            </template>
        </modal>

        <modal :show.sync="modalPagarMes">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Marcar mes como pagado</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Seleccionar dia</strong></label>
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                            <flat-picker slot-scope="{focus, blur}"
                                         @on-open="focus"
                                         @on-close="blur"
                                         :config="configDate"
                                         class="form-control datepicker"
                                         v-model="modalPagarMesData.date">
                            </flat-picker>
                        </base-input>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalPagarMes = false">Cerrar</base-button>
                <base-button type="primary"
                             @click="pagarMes(modalPagarMesData.player, modalPagarMesData.sino, modalPagarMesData.pay, modalPagarMesData.option)">
                    Guardar
                </base-button>
            </template>
        </modal>
        <modal :show.sync="modalPagarMatricula">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Marcar matricula como pagada</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Seleccionar dia</strong></label>
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                            <flat-picker slot-scope="{focus, blur}"
                                         @on-open="focus"
                                         @on-close="blur"
                                         :config="configDate"
                                         class="form-control datepicker"
                                         v-model="modalPagarMatriculaData.date">
                            </flat-picker>
                        </base-input>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalPagarMatricula = false">Cerrar</base-button>
                <base-button type="primary"
                             @click="changeMatricula(modalPagarMatriculaData.player, 1)">
                    Guardar
                </base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2'
import flatPicker from "vue-flatpickr-component";
import {Spanish} from 'flatpickr/dist/l10n/es'
import "flatpickr/dist/flatpickr.css";

export default {
    data() {
        return {
            player: {},
            newPay: {
                date: "today",
                status: "0",
                value: 0
            },
            configDate: {
                allowInput: false,
                altFormat: 'd-m-Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                locale: Spanish
            },
            nuevaInscripcion: {
                modalidad: null,
                posicion: 0,
                year: "2002",
                sede: "Sevilla Este",
                dia: "1",
                hora: {},
                hora1Id: null,
                hora2Id: null,
                dia2: "0",
                hora2: {},
            },
            modalPagarMes: false,
            modalPagarMesData: {
                player: null,
                sino: null,
                option: null,
                date: 'today',
                pay: null
            },
            modalPagarMatricula: false,
            modalPagarMatriculaData: {
                player: null,
                date: 'today'
            },
            horas: [],
            horas2: [],
            modalidades: [],
            coaches: [],
            coachId: 0,
            inputFile: "",
            selectedFile: null,
            type: this.$store.getters.type,
            modalEditPlayer: false,
            modalAddCoach: false,
            modalChangeInscripcion: false,
            playerEdit: {},
            cuotaMatricula: 20
        };
    },
    components: {flatPicker},
    created() {
        this.loadPlayer();
        this.loadCoaches();
    },
    methods: {
        loadModalidades() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'modalidades?sede=' + vm.nuevaInscripcion.sede)
                .then(response => {
                    if (response.data.response) {
                        vm.modalidades = response.data.result;
                        vm.nuevaInscripcion.modalidad = vm.modalidades[0];
                        vm.loadHoras();
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        loadHoras(dia) {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'horas', {
                params: {
                    posicion: this.player.posicion === 'Portero' ? 2 : 1,
                    sede: vm.nuevaInscripcion.sede,
                    dia: dia === 2 ? vm.nuevaInscripcion.dia2 : vm.nuevaInscripcion.dia,
                    grupal: vm.nuevaInscripcion.modalidad.maxPlayers
                }
            }).then(response => {
                if (response.data.response) {
                    if (dia === 1) {
                        vm.horas = response.data.result;
                        vm.nuevaInscripcion.hora = vm.horas[0]
                        vm.nuevaInscripcion.horaId = vm.horas[0].id
                    } else if (dia === 2) {
                        vm.horas2 = response.data.result;
                        vm.nuevaInscripcion.hora2 = vm.horas2[0]
                        vm.nuevaInscripcion.hora2Id = vm.horas2[0].id
                    } else {
                        vm.horas = response.data.result;
                        vm.nuevaInscripcion.hora = vm.horas[0]
                        vm.nuevaInscripcion.horaId = vm.horas[0].id
                        vm.horas2 = response.data.result;
                        vm.nuevaInscripcion.hora2 = vm.horas2[0]
                        vm.nuevaInscripcion.hora2Id = vm.horas2[0].id
                    }

                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        openModalPagarMes(player, sino, pay, option) {
            this.modalPagarMesData.player = player;
            this.modalPagarMesData.sino = sino;
            this.modalPagarMesData.option = option;
            this.modalPagarMesData.pay = pay;
            this.modalPagarMes = true;
        },
        changeInscripcion() {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/change-inscripcion', {
                inscripcion: this.nuevaInscripcion,
                id: this.player.id,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.loadPlayer();
                    vm.modalChangeInscripcion = false;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        openModalMatricula(player) {
            this.modalPagarMatriculaData.player = player;
            this.modalPagarMatricula = true;
        },
        loadPlayer() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'players/' + this.$route.params.id, {
                params: {
                    jwt: vm.$store.getters.jwt
                }
            }).then(response => {
                if (response.data.response) {
                    vm.player = response.data.result;
                    if (vm.player.inscripcion) {
                        vm.loadModalidades();
                    }
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        pagarMes(sino, mes, pay, option) {
            const playerId = this.player.id;
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + playerId + '/pagar-mes', {
                idPlayer: playerId,
                mes: mes,
                sino: sino,
                date: vm.modalPagarMesData.date,
                jwt: this.$store.getters.jwt,
                season: vm.$store.getters.season,
                option: option
            }).then(response => {
                if (response.data.response) {
                    this.modalPagarMes = false;
                    vm.loadPlayer();
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        addPay() {

            if (this.newPay.value != 0) {
                let vm = this;
                axios.post(this.$store.getters.apiUrl + 'payments', {
                    idPlayer: this.player.id,
                    newPay: this.newPay,
                    jwt: this.$store.getters.jwt
                }).then(response => {
                    if (response.data.response) {
                        vm.player.payments.push(response.data.result);

                        var newPay = {
                            date: "today",
                            status: "0",
                            value: 0
                        };

                        vm.newPay = newPay;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            } else {
                swal({
                    title: 'Atención',
                    text: "Introduce un valor del pago",
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
            }

        },
        modalConfirm(pay) {
            swal({
                title: '¿Está seguro de confirmar este pago?',
                text: `Esta operación no se puede deshacer`,
                type: 'info',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, confirmar pago',
                cancelButtonText: 'Cancelar',
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.confirmPay(pay);
                }
            })

        },
        confirmPay(pay) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'payments/' + pay.id + '/confirm', {
                idPay: pay.id,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    pay.status = 1;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        modalDelete(pay) {
            swal({
                title: '¿Está seguro de eliminar este pago?',
                text: `Esta operación no se puede deshacer`,
                type: 'info',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, eliminar pago',
                cancelButtonText: 'Cancelar',
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.deletePay(pay);
                }
            })

        },
        changeMatricula(player, matricula) {
            player.matricula = matricula;
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + player.id + '/change-matricula', {
                idPlayer: player.id,
                matricula: matricula,
                cuotaMatricula: this.cuotaMatricula,
                date: this.modalPagarMatriculaData.date,
                jwt: this.$store.getters.jwt,
                season: vm.$store.getters.season
            }).then(response => {
                if (response.data.response) {
                    if(matricula === 1){
                        this.modalPagarMatricula = false;
                    }
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        deletePay(pay) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'payments/' + pay.id + '/delete', {
                idPay: pay.id,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    var index = vm.player.payments.findIndex(x => x.id === pay.id);
                    vm.player.payments.splice(index, 1);

                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        editPlayer() {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + vm.playerEdit.id, {
                playerEdit: vm.playerEdit,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.modalEditPlayer = false;
                    vm.loadPlayer();
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        uploadImage(event) {
            this.selectedFile = this.$refs.file.files[0];

            let formData = new FormData();
            formData.append('file', this.selectedFile);
            formData.append('jwt', this.$store.getters.jwt);
            formData.append('id', this.player.id);

            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/change-img',
                formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {
                if (response.data.response) {
                    vm.selectedFile = "";
                    vm.inputFile = "";
                    vm.player.img = response.data.result;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(function (e) {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
            });


        },
        openModalDeletePlayer(idPlayer) {
            swal({
                title: '¿Desea eliminar este jugador?',
                text: `Esta operación no se puede deshacer`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, borrar jugador',
                cancelButtonText: 'Cancelar',
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.deleteJugador(idPlayer);
                }
            });

        },
        changeDia() {
            if (this.nuevaInscripcion.sede === 'Sevilla Este') {
                this.nuevaInscripcion.dia = '0';
            }
            if (this.nuevaInscripcion.sede === 'Torreblanca') {
                this.nuevaInscripcion.dia = '2';
            }
            if (this.nuevaInscripcion.sede === 'Castilleja Cuesta') {
                this.nuevaInscripcion.dia = '2';
            }
        },
        deleteJugador(idPlayer) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + idPlayer + '/delete', {
                idPlayer: idPlayer,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.$router.push({path: '/admin/jugadores'});
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        openModalReservaPlayer(idPlayer) {
            swal({
                title: '¿Desea sacar de la lista de reservas a este jugador?',
                text: ``,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, sacar de la reserva',
                cancelButtonText: 'Cancelar',
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.reservaJugador(idPlayer);
                }
            });

        },
        reservaJugador(idPlayer) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + idPlayer + '/reserva', {
                idPlayer: idPlayer,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.player.reserva = 0;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        openModalBajaPlayer(idPlayer) {
            swal({
                title: '¿Desea dar de baja este jugador?',
                text: `Luego podras darlo de alta de nuevo`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, dar de baja al jugador',
                cancelButtonText: 'Cancelar',
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.bajaJugador(idPlayer);
                }
            });

        },
        bajaJugador(idPlayer) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + idPlayer + '/baja', {
                idPlayer: idPlayer,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.player.baja = 1;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        openModalAltaPlayer(idPlayer) {
            swal({
                title: '¿Desea dar de alta este jugador?',
                text: `Luego podras darlo de baja de nuevo`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, dar de alta al jugador',
                cancelButtonText: 'Cancelar',
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.altaJugador(idPlayer);
                }
            });

        },
        altaJugador(idPlayer) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + idPlayer + '/alta', {
                idPlayer: idPlayer,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.player.baja = 0;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        loadCoaches() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'coaches', {
                params: {
                    jwt: vm.$store.getters.jwt,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.coaches = response.data.result;
                    vm.coachId = vm.coaches[0].id;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        addCoach() {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + this.$route.params.id + '/entrenador', {
                idPlayer: this.player.id,
                coachId: this.coachId,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.loadPlayer();
                    vm.modalAddCoach = false;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        modalDeleteCoach(coachId) {
            swal({
                title: '¿Está seguro de eliminar este entrenador al jugador?',
                text: `Esta operación no se puede deshacer`,
                type: 'info',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, eliminar entrenador',
                cancelButtonText: 'Cancelar',
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.deleteCoach(coachId);
                }
            })
        },
        deleteCoach(coachId) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + this.$route.params.id + '/entrenador/' + coachId + '/delete', {
                idPlayer: this.$route.params.id,
                coachId: coachId,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.loadPlayer();
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
            });
        },

    },
    computed: {

        getTotalPayments() {
            let total = 0;

            this.player.payments.forEach(function (p) {
                total += p.value;
            });

            return total;

        },
        getTotalPagado() {
            let pagado = 0;

            if (this.player) {
                this.player.payments.forEach(function (p) {
                    if (p.status == 1) {
                        pagado += p.value;
                    }
                });
            }

            return pagado;
        }
    }

};
</script>
<style scoped>

.container-fluid {
    margin-top: 39px;
}

.card {
    padding: 20px;
    background-color: #f7fafc !important;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: .375rem;
}

#img-player {
    margin-top: 30px;
    /*max-width: 100px;*/
}

#ficha {
    border: 2px solid #3e5c4a;
    border-radius: 5px;
    padding: 10px 20px;
}

.ficha-title {
    text-align: center;
    font-size: 1.1em;
    padding-top: 5px;
}

.ficha-details {
    font-size: 1.5em;
    color: #3e5c4a;
    margin-bottom: 10px;
    text-align: right;
}

#table-pays td {
    vertical-align: middle;
}

.imgPlayer:hover {
    cursor: pointer;
    background-color: #000;
    opacity: 0.6;
    border-radius: 5px;
}

.list-services td {
    font-size: 1em;
}

@media (max-width: 600px) {
    #nombre-player {
        margin-top: 20px;
        text-align: center;
    }

    #ficha {
        margin-top: 40px;
    }

    .ficha-title {
        text-align: left !important;
    }

    .ficha-details {
        text-align: center !important;
    }
}


</style>
